import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
                        <h2><span>Flutter Mobile</span> Application Development For Different Industries</h2>
                        <p>We excel in creating versatile mobile apps using Flutter to meet the unique requirements of various industries. Our solutions smoothly align with your business needs, delivering efficient and user-friendly applications for sustained success across diverse sectors. </p>
                        <p>Here are the diverse industries that we cater to:</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Build Your Flutter App</Link>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4} className="offset-lg-3 offset-md-3  my-auto">
                        <div className="industry_scroll">
                            <h3>Retail </h3>
                            <h3>E-commerce</h3>
                            <h3>Insurance</h3>
                            <h3>FinTech</h3>
                            <h3>Entertainment</h3>
                            <h3>Health & Fitness</h3>
                            <h3>Lifestyle </h3>
                            <h3>Education</h3>
                            <h3>Real Estate</h3>
                            <h3>Logistics</h3> 
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Industryusa